<div style="display: flex; flex-direction: column; text-align: center;">
    <p>The requested document is {{fileSize | number:'1.1-1'}} MB in size and might be slow to view.</p>
    <div>
        <button mat-stroked-button (click)="pageView.emit()">Switch to Page View (faster)</button>
        &nbsp;
        <button mat-stroked-button (click)="viewAsNative()">Stay in Doc View (slower)</button>
    </div>

    <p>Estimated Download Times:</p>
    <table>
        <tr>
            <td>Very Fast Office (T-3)</td>
            <td>{{t3Time | number:'1.0-0'}} min</td>
        </tr>
        <tr>
            <td>Fast Home (Turbo Cable)</td>
            <td>{{turboCableTime | number:'1.0-0'}} min</td>
        </tr>
        <tr>
            <td>Regular Home (Cable/DSL)</td>
            <td>{{cableDslTime | number:'1.0-0'}} min</td>
        </tr>
        <tr>
            <td>Regular Office (T-1)</td>
            <td>{{t1Time | number:'1.0-0'}} min</td>
        </tr>
    </table>
</div>
